import { h } from '@stencil/core';
import { applyProps } from '../common';
const Breadcrumbs = (props, children) => (h("ul", Object.assign({}, applyProps(props, { class: 'ui-breadcrumbs' })), children));
export default Breadcrumbs;
